module.exports = __webpack_public_path__ + "img/daily-mail.a4b221ee.png";